import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { HttpService } from '../../../http.service';
import { environment } from '../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
   user_detail : any =[]; 
   userSavedAddressError : any =''; 
   userSavedAddress : any =[]; 
   addAddressType : any = '' ;
   userImage : String = '' ;
   edit_customlable_input : String = '' ;
   activeTab : String = 'profile' ;
   profileImageSpin : Number =0 ;
   addAddressSpin : Number =0 ;
   profileSpin : Number =0 ;
   isLogout : any =0 ;
   porfileupdatemessge : any ='' ;
   profileform : FormGroup;
   isSubmitted  =  false;
   BASEURL_RES_IMGS = environment.BASEURL_RES_IMGS;

  constructor(
	private _http: HttpService,
	private formBuilder: FormBuilder,
	) { }

  ngOnInit(): void {
	$('.invalid-number').hide();
	this.profileform  =  this.formBuilder.group({
            //email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            email: ['', [Validators.required]],
            phone_no: ['', [Validators.required]],
			fullname: ['', Validators.required],
		});
		  
	if(localStorage.getItem('user_detail')!=null) {
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
		this.profileform.patchValue (
			{
				email:this.user_detail.email, 
				fullname:this.user_detail.fullname, 
				phone_no:this.user_detail.phone_no
			}
		);
	    if (this.user_detail.image) {
			this.userImage = this.BASEURL_RES_IMGS+this.user_detail.image;
		}
		this.getUserSavedAddress();
	}

  }
	get formControls() { return this.profileform.controls; }

    getUserSavedAddress () {
		const userAddress = new FormData();
		userAddress.append( 'user_id', this.user_detail.id );
		this._http.postRequest('getuser_address.php',userAddress).subscribe((response : any)=>{
			if (response.user_address && response.user_address!='no record found') {
				
				this.userSavedAddress = response.user_address;
				this.user_detail.user_address = response.user_address;
				localStorage.setItem('user_detail', JSON.stringify(this.user_detail));

			} else {
				this.userSavedAddress = [];
				this.user_detail.user_address = [];
				localStorage.setItem('user_detail', JSON.stringify(this.user_detail));
			}
			
		}) 
	}
    profileformupdate () {
	$('.invalid-number').hide();

	this.isSubmitted = true;
	if(this.profileform.invalid){
	  return;
	}
	var is_number_valid = this.isAmericanNumber(this.profileform.value.phone_no);
	if (is_number_valid==false) {
		$('.invalid-number').show();
		return ;
	}
	
	this.porfileupdatemessge = '';
	this.profileSpin = 1;
	const updateProfile = new FormData();
	updateProfile.append( 'phone_no', this.profileform.value.phone_no );
	updateProfile.append( 'email', this.profileform.value.email );
	updateProfile.append( 'fullname', this.profileform.value.fullname );
	updateProfile.append( 'res_id', '49' );
	updateProfile.append( 'user_id', this.user_detail.id );
	this._http.postRequest('update_profile.php',updateProfile).subscribe((response : any)=>{
		if (response[0].error) {
			this.porfileupdatemessge = response[0].error;
		} else {
			this.porfileupdatemessge = response[0].msg;
			this.user_detail.email =this.profileform.value.email;
			this.user_detail.fullname =this.profileform.value.fullname;
			this.user_detail.phone_no =this.profileform.value.phone_no;
			localStorage.setItem('user_detail' ,JSON.stringify(this.user_detail));
		}
		this.profileSpin=0;
	}) 
  }
  updateUrlInvalidProfile (url) {
	(document.getElementById('profileImage') as HTMLImageElement).src = url;
  
  }
  uploadImage (event,type) {
		const file = (event.target as HTMLInputElement).files[0];
		this.profileImageSpin=1;
		const formData = new FormData();
		formData.append('profile_image', file);
   	    formData.append( 'user_id', this.user_detail.id );
		this.porfileupdatemessge = '';

		this._http.postRequest('update_profile.php',formData).subscribe((response : any)=>{
			this.profileImageSpin=0;
			if (response[0].error) {
			this.porfileupdatemessge = response[0].error;
			//(document.getElementById('profileImage') as HTMLImageElement).src
			} else {
				if (response[0].data){
					if(response[0].data.image_name) {
						this.userImage = this.BASEURL_RES_IMGS+response[0].data.image_name;
						this.user_detail.image =response[0].data.image_name;
						localStorage.setItem('user_detail' ,JSON.stringify(this.user_detail));
					}
				}
				this.porfileupdatemessge = 'Profile Image has been uploaded';
			}	
		},(error :any) => {
			this.profileImageSpin=0;
		}
		);
	 }
  addAddressModal () {
	  $('#addAddressModal').modal('show');
	  $('#profile_address').val('');
	  $('#profile_lat').val('');
	  $('#profile_lng').val('');
	  $('#profile_city').val('');
	  $('#profile_state').val('');
	  $('#profile_country').val('');
	  $('#profile_postalcode').val('');
	  $('#profile_apartment').val('');
	  $('#profile_crossstreet').val('');
	  $('#customlable_input').val('');
	  this.addAddressType='';
	  this.userSavedAddressError='';
  }	
  	handleAddressChange(address) {
		var deliveryAddress = [];
		var lat = address.geometry.location.lat();
		var lng = address.geometry.location.lng();
		
		$('#profile_lat').val(lat);
		$('#profile_lng').val(lng);
		
		var fulladdress = address.formatted_address;
		deliveryAddress.push({lat:lat});
		deliveryAddress.push({lng:lng});
		deliveryAddress.push({fulladdress:fulladdress});
		for(let i=1; i<address.address_components.length;i++)
		{
			var mapAddress = address.address_components[i];
			if(mapAddress.long_name !=''){
				if(mapAddress.types[0] ==="administrative_area_level_1"){
                 	$('#profile_state').val(mapAddress.long_name);
				}
				if(mapAddress.types[0] ==="locality"){
                  $('#profile_city').val(mapAddress.long_name);

				}
				 if(mapAddress.types[0] ==="postal_code"){
				   $('#profile_postalcode').val(mapAddress.long_name);
				}
				if(mapAddress.types[0] ==="street_number"){
				   $('#profile_apartment').val(mapAddress.long_name);
				}
				if(mapAddress.types[0] ==="country"){
				   $('#profile_country').val(mapAddress.long_name);
				}
            
			}
		}
		
	}
	selectAddType (type) {
		this.addAddressType=type;
		this.edit_customlable_input='';
	}
	saveLabel (type) {
		if(type==='save') {
			var edit_customlable_input= $('#edit_customlable_input').val();
			var customlable_input= $('#customlable_input').val();
			//this.addAddressType = customlable_input;
		} else {
			 $('#customlable_input').val('');
			 $('#edit_customlable_input').val('');
			this.addAddressType = '';
		}
		
	}
	saveAddAddress () {
		var address = $('#profile_address').val();
		var lat = $('#profile_lat').val();
		var lng = $('#profile_lng').val();
		
		var country = $('#profile_country').val();
		var state = $('#profile_state').val();
		var postal_code = $('#profile_postalcode').val();
		var apartment = $('#profile_apartment').val();
		var street = $('#profile_crossstreet').val();
		var city = $('#profile_city').val();
		if (address==='' || city ==='' || state==='') {
			this.userSavedAddressError='Please fill all the required fields first';
		} else if (lat==='' || lng ==='' ) {
			this.userSavedAddressError='Please add the proper address of google locations';
		} else {
			this.addAddressSpin=1;
			var addressType=this.addAddressType;
			if (this.addAddressType!='Home' && this.addAddressType!='Work') {
				addressType =$('#customlable_input').val();
			}
			const userAddress = new FormData();
			userAddress.append( 'user_id', this.user_detail.id );
			userAddress.append( 'address', address);
			userAddress.append( 'lat', lat);
			userAddress.append( 'lng', lng);
			userAddress.append( 'country', country);
			userAddress.append( 'state', state);
			userAddress.append( 'postal_code', postal_code);
			userAddress.append( 'apartment', apartment);
			userAddress.append( 'street', street);
			userAddress.append( 'type', addressType);
			userAddress.append( 'city', city);
			this._http.postRequest('user_address.php',userAddress).subscribe((response : any)=>{
				this.getUserSavedAddress();
				$('#addAddressModal').modal('hide');
				alert('Address has been added.');

				this.addAddressSpin=0;
			});
		}
	}
	deleteAddress (data) {
		const userAddress = new FormData();
		userAddress.append( 'id', data.id );
		this._http.postRequest('user_address_delete.php',userAddress).subscribe((response : any)=>{
			this.getUserSavedAddress();
			alert('Address has been deleted.');

		});
	}
	editAddress (data) {
		this.addAddressSpin = 0;
		$('#editAddressModal').modal('show');
		$('#edit_profile_id').val(data.id);
		$('#edit_profile_address').val(data.address);
		$('#edit_profile_lat').val(data.lat);
		$('#edit_profile_lng').val(data.lng);
		$('#edit_profile_city').val(data.city);
		$('#edit_profile_state').val(data.state);
		$('#edit_profile_country').val(data.country);
		$('#edit_profile_postalcode').val(data.postal_code);
		$('#edit_profile_apartment').val(data.apartment);
		$('#edit_profile_crossstreet').val(data.street);
		if (data.type!='Work' && data.type!='Home') {
			this.addAddressType='customlable';
		} else {
			this.addAddressType=data.type;
		}
		this.edit_customlable_input=data.type;

		
		this.userSavedAddressError='';
	}
	edithandleAddressChange(address) {
		var deliveryAddress = [];
		var lat = address.geometry.location.lat();
		var lng = address.geometry.location.lng();
		
		$('#edit_profile_lat').val(lat);
		$('#edit_profile_lng').val(lng);
		
		var fulladdress = address.formatted_address;
		deliveryAddress.push({lat:lat});
		deliveryAddress.push({lng:lng});
		deliveryAddress.push({fulladdress:fulladdress});
		for(let i=1; i<address.address_components.length;i++)
		{
			var mapAddress = address.address_components[i];
			if(mapAddress.long_name !=''){
				if(mapAddress.types[0] ==="administrative_area_level_1"){
                 	$('#edit_profile_state').val(mapAddress.long_name);
				}
				if(mapAddress.types[0] ==="locality"){
                  $('#edit_profile_city').val(mapAddress.long_name);

				}
				 if(mapAddress.types[0] ==="postal_code"){
				   $('#edit_profile_postalcode').val(mapAddress.long_name);
				}
				if(mapAddress.types[0] ==="street_number"){
				   $('#edit_profile_apartment').val(mapAddress.long_name);
				}
				if(mapAddress.types[0] ==="country"){
				   $('#edit_profile_country').val(mapAddress.long_name);
				}
            
			}
		}
		
	}
	updateAddAddress () {
		var address = $('#edit_profile_address').val();
		var id = $('#edit_profile_id').val();
		var lat = $('#edit_profile_lat').val();
		var lng = $('#edit_profile_lng').val();
		
		var country = $('#edit_profile_country').val();
		var state = $('#edit_profile_state').val();
		var postal_code = $('#edit_profile_postalcode').val();
		var apartment = $('#edit_profile_apartment').val();
		var street = $('#edit_profile_crossstreet').val();
		var city = $('#edit_profile_city').val();
		if (address==='' || city ==='' || state==='') {
			this.userSavedAddressError='Please fill all the required fields first';
		} else if (lat==='' || lng ==='' ) {
			this.userSavedAddressError='Please add the proper address of google locations';
		} else {
			this.addAddressSpin=1;
			var addressType=this.addAddressType;
			if (this.addAddressType!='Home' && this.addAddressType!='Work') {
				addressType =$('#edit_customlable_input').val();
			}
			const userAddress = new FormData();
			userAddress.append( 'user_id', this.user_detail.id );
			userAddress.append( 'address', address);
			userAddress.append( 'lat', lat);
			userAddress.append( 'lng', lng);
			userAddress.append( 'country', country);
			userAddress.append( 'state', state);
			userAddress.append( 'postal_code', postal_code);
			userAddress.append( 'apartment', apartment);
			userAddress.append( 'street', street);
			userAddress.append( 'type', addressType);
			userAddress.append( 'city', city);
			userAddress.append( 'id', id);
			this._http.postRequest('user_address_update.php',userAddress).subscribe((response : any)=>{
				this.getUserSavedAddress();
				$('#editAddressModal').modal('hide');
				alert('Address has been updated.');
				this.addAddressSpin=0;
			});
		}
	}
	changeTab (type) {
		this.activeTab = type;
	}
	isAmericanNumber(str) {
	    var isphone = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(str);
		return isphone;	
	}
}
